import { contentTable, index, text } from "@-/dev.improve.haniverse.lib.database.table";

export const appWordMeaningCardTable = contentTable(
  "app_word_meaning_card",
  {
    word: text("word").notNull(),
  },
  (table) => [index("app_word_meaning_card_word_idx").on(table.word)],
);

export type AppWordMeaningCard = typeof appWordMeaningCardTable.$inferSelect;
